
import {Box, Button} from "@mui/material";
import MuiTableWrapper from "../../components/common/mui-table-wrapper/MuiTableWrapper";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import React, {useEffect, useState} from "react";
import StarCheckbox from "../../components/common/star-checkbox/StarCheckbox";
import FormSearchFilter from "../../components/common/form-search-filter/FormSearchFilter";
import {get, post} from "../../common/network";
import useToaster from "../../components/common/toaster/useToaster";
import FallbackGeneratedFormMessage from "../../components/common/fallback-form-message/FallbackGeneratedFormMessage";
import SidebarTagsWrapper from "../../components/common/sidebar-tags-wrapper/SidebarTagsWrapper";
import SidebarTagsDrawer from "../../components/common/sidebar-tags-wrapper/SidebarTagsDrawer";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import MultiFilter from "../../components/multi-filter/Multifilter";
import { getNestedValue, normalizeDate } from "../../utils/CommonMethods";
import { FormTypeOptions } from "../../constants";

const Favourites = () => {
  const toaster = useToaster();
  //#region for states
  const [selectedRows, setSelectedRows] = useState([]); // Array of the selected rows
  const [favFormList, setFavFormsList] = useState([]); // Array of favourite form
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [formTypeValue, setFormTypeValue] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [rowsSelection,setRowsSelection] = useState([]);
  const [dynamicFilters, setDynamicFilters] = useState([
      { column: '', operator: '', value: [], from: null, to: null }
  ]);
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [filteredData, setFilteredData] = useState([]);

  const multiFilterColumns = [
    {
        field: "form_name",
        headerName: "Form Name",
        type: "text",
    },
    {
        field: "form_code",
        headerName: "Form Code",
        type: "text",
    },
    {
        field: "form_type",
        headerName: "Type",
        type: "select",
        options: FormTypeOptions
    },
    {
        field: "country",
        headerName: "Country",
        type: "text",
    },
  ];

  // HANDLE DOWNLOAD FUNCTION
  const handleDownload = () => {  
        downloadForms();
  };
  // HANDLE DOWNLOAD FUNCTION

  //call download api
  const downloadForms = async () => {
    try {
      setIsLoading(true);
      const selectedIds = [];
      for (const row of selectedRows) {
        selectedIds.push(row.id);
      }
      const response = await post(
        `docgen/forms/download`,
        {
          form_id: selectedIds,
        },
        {
          responseType: "blob", // Specify that you expect a Blob response
        },
        false
      );
      // Get the current timestamp
      const timestamp = new Date().getTime();

      const contentDispositionHeader =
      response?.headers["content-disposition"];
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDispositionHeader);
      let suggestedFilename;
      if (selectedIds.length!==1) {
          suggestedFilename = `forms-${timestamp}.zip`;
      } else {
          suggestedFilename = matches && matches[1] && matches[1].replace(/['"]/g, "");
      }
      
      // Create a Blob from the response content
      const mimeType = response?.headers["content-type"];
      const blob = new Blob([response.data], {type: mimeType});

        // Create a URL for the blob response
        const url = URL.createObjectURL(blob);

        // Create a hidden anchor element
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.href = url;
        anchor.download = suggestedFilename; // Set the desired file name

        // Append the anchor to the document body
        document.body.appendChild(anchor);

        // Simulate a click on the anchor to trigger the download
        anchor.click();

        // Remove the anchor from the document body
        document.body.removeChild(anchor);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const applyMultiFilters = (rows, filters) => {
    if (!filters || !filters.length) return rows;

    return rows.filter(row =>
        filters.every(filter => {
            const { column, operator, value, from, to } = filter;
            // const rowValue = row[column];
            const rowValue = getNestedValue(row, column);

            // EMPTY CHECKS
            if (operator === 'isEmpty') {
                return rowValue === null || rowValue === undefined || rowValue === '';
            }

            if (operator === 'isNotEmpty') {
                return rowValue !== null && rowValue !== undefined && rowValue !== '';
            }

            // DATE RANGE
            if ((operator === 'equals' || operator === 'notEquals') && from) {
                if (!rowValue || !from) return false;

                const rowDate = new Date(rowValue).toISOString().split('T')[0];
                const filterDate = new Date(from).toISOString().split('T')[0];

                return operator === 'equals'
                    ? rowDate === filterDate
                    : rowDate !== filterDate;
            }

            if (operator === 'between') {
                if (!rowValue || !from || !to) return false;

                const rowDate = new Date(rowValue);

                const startDate = new Date(from);
                startDate.setHours(0, 0, 0, 0);

                const endDate = new Date(to);
                endDate.setHours(23, 59, 59, 999); 

                return rowDate >= startDate && rowDate <= endDate;
            }

            // MULTI-SELECT DROPDOWN
            if (Array.isArray(value) && value.length > 0) {
                if (Array.isArray(rowValue)) {
                    if (operator === 'doesNotContains' || operator === 'notEquals') {
                    return !rowValue.some(v => value.includes(v));
                    }
                    return rowValue.some(v => value.includes(v));
                }

                if (operator === 'doesNotContains' || operator === 'notEquals') {
                    return !value.includes(rowValue);
                }

                return value.includes(rowValue);
            }
              
              // If value array is empty, show all rows
              if (Array.isArray(value) && value.length === 0) {
                  return true;
              }

            // TEXT COMPARISON
            const cell = String(rowValue ?? '').toLowerCase();
            const search = String(value ?? '').toLowerCase();

            switch (operator) {
                case 'contains':
                    return cell.includes(search);
                case 'doesNotContains':
                    return !cell.includes(search);
                case 'equals':
                    return cell === search;
                case 'notEquals':
                    return cell !== search;
                case 'startsWith':
                    return cell.startsWith(search);
                case 'endsWith':
                    return cell.endsWith(search);
                default:
                    return true;
            }
        })
    );
  };

  const handleApplyFilters = (filters) => {
    // Clear single search state
    setSearchValue("");
    setFilterText("");
    setFormTypeValue("");
    setDateValue("");
    setSearchResetKey(prev => prev+1);
    // Store active multi-filters
    setDynamicFilters(filters);

    const normalizedFilters = filters.map(f => ({
        ...f,
        from: normalizeDate(f.from),
        to: normalizeDate(f.to)
    }));
    const result = applyMultiFilters(data, normalizedFilters);
    setFilteredData(result);
  };

  const favoriteList = [];

  const columns = [
    {
      field: "form_name",
      header: "Form Name",
      render: (value, row) => {
        return (
          <div 
          style={{textDecoration:"underline", cursor:"pointer",paddingTop:"0.5%", paddingBottom:"0.5%"}}
            onClick={() => {
                window.open(`/docgen/form/details?id=${row.id}`);
              }}>
             {value}   
          </div>
        );
      },
    },
    {
      field: "form_code",
      header: "Form Code",
    },
    {
      field: "form_type",
      header: "Type",
    },
    {
      field: "country",
      header: "Country",
    },
    {
      field: "favourite",
      header: "",
      filter: false,
      sort: false,
      render: (value, row) => {
        return (
          <StarCheckbox
            isSelected={
              row.favorite_form_details ? true : favFormList.includes(row.id)
            }
            changeEvent={() => {
              if (favFormList.includes(row.id) || row.favorite_form_details) {
                handleUnFavorite(row.id);
              } else {
                handleFavorite(row.id);
              }
            }}
          />
        );
      },
    },
  ];

  const handleFavorite =  async (id) => {
    try {
      const response = await post(`docgen/forms/favorite`, {
        formIds: [{ formId: id, status: true }],
      });
      if (response?.success === true) {
        toast.success(response.message);
        setFavFormsList((prevList) => [...prevList, id]);
      }
    } catch (error) {
    } finally{
      setSelectedRows([]);
    }
  };

  const handleUnFavorite = async (id) => {
      try {
        const response = await post(`docgen/forms/favorite`, {
          formIds: [{ formId: id, status: false }],
        });
        if (response?.success === true) {
          setFavFormsList((prevList) => prevList.filter((form) => form !== id));
          toast.success(response.message);
          fetchFavData();
        }
      } catch (error) {
      } finally {
        setSelectedRows([]);
      }
  };

  const handleSearch = (value) => {
    setDynamicFilters([{ column: '', operator: '', value: [], from: null, to: null }]);
    const columnName = value?.value || ""; // Name of the column
    const searchValue = value?.searchedText || ""; // Value entered in the input field
    const dropdownValue = value?.dropdownValue || ""; // value selected in the dropdown field
    setSearchValue(searchValue);
    setFilterText(columnName);
    setFormTypeValue(dropdownValue);

    if (columnName === "updated_at") {
      setDateValue(value);
    }
    setFilteredData(data);
  };

  const fetchFavData = async () => {
    setIsFetching(true);                      
    try {
      const response = await get(
        `docgen/forms/favorite`               
      );
      setData(response.data);
    } catch (error) {
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchFavData();
  }, []);

  useEffect(() => {
      setFilteredData(data);
  }, [data]);

  const handleRedirect = () => {
    const queryParams = new URLSearchParams();
    const selectedIds = [];
    for (const row of selectedRows) {
      selectedIds.push(row.id);
    }
    selectedIds.forEach((id) => queryParams.append("id", id));
    window.open(`/docgen/favorite-forms/preview?` + queryParams);
  };

  return (
    <SidebarTagsWrapper
      active={selectedRows.length > 0}
      component={
        <SidebarTagsDrawer
          lowerSectionProps={{
            title: "Forms Selected",
            setSelectedRows: setSelectedRows,
            selectedRows: selectedRows,
            tagName: "code",
          }}
          buttonProps={{
            title: "Select Docket(s)",
            onClick: () => {
              navigate("/docgen/forms/matters", {
                state: { selectedRows },
              });
            },
          }}
        />
      }
    >
      <div className="page-content-wrapper">
        <Box className="w-100">
          <header className="section-heading">
            <div className="left-area">
              <FormSearchFilter
                options={[
                  { value: "", label: "All" },
                  { value: "form_name", label: "Form Name" },
                  { value: "form_code", label: "Form Code" },
                  { value: "form_type", label: "Type" },
                  { value: "country", label: "Country" },
                ]}
                defaultOption = { {value: "", label: "Select an option"} }
                dateFiltersOptionsValueArray={[]}
                dropdownArray={["form_type"]}
                dropdownOptions={{
                  form_type: [
                    {
                      value: "standard",
                      label: "Standard",
                    },
                    {
                      value: "custom",
                      label: "Custom",
                    },
                  ],
                }}
                onSearch={(values) => handleSearch(values)}
                searchResetKey={searchResetKey}
              />
            </div>
            <div className="right-area">
              <section className="top-actions-section">
                <div className="buttons-group">
                  <ul>
                  {selectedRows.length > 0 && (
                      <>
                      <li>
                        <Button type="button" onClick={() => handleRedirect()}>
                          <div className="icon-area">
                            <RemoveRedEyeOutlinedIcon />
                          </div>
                          <p className="text-area">Preview</p>
                        </Button>
                      </li>
                      <li>
                      <Button type="button" onClick={() => handleDownload()}>
                        {isLoading ?  <CircularProgress sx={{ color: "blue", marginLeft: "5%" }} />:
                        <>
                        <div className="icon-area">
                          <FileDownloadOutlinedIcon />
                        </div>
                        <p className="text-area">Download</p>
                        </>}
                      </Button>
                      </li>
                      </>
                  )}

                    <li>
                      <MultiFilter 
                          filters={dynamicFilters}
                          setFilters={setDynamicFilters}
                          columns={multiFilterColumns}
                          onAddFilter={handleApplyFilters} 
                      />
                    </li>
                  </ul>
                </div>
              </section>
            </div>
          </header>
            <MuiTableWrapper
              columns={columns}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              colgroup={[
                {width: "50%"},
                {width: "20%"},
                {width: "10%"},
                {width: "10%"}
              ]}
              emptyBody={
                <FallbackGeneratedFormMessage searchedKeyword={searchValue}/>
              }
              searchValue={searchValue}
              filterColumn={filterText}
              formTypeValue={formTypeValue}
              data={filteredData}
              isFetching={isFetching}
              dateValue={dateValue}
              rowsSelection={rowsSelection}
              setRowsSelection={setRowsSelection}
            />
        </Box>
      </div>
    </SidebarTagsWrapper>
  );
};

export default Favourites;
